
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

import SectionNucleoIcons from 'views/index-sections/SectionNucleoIcons';
import Clients from 'views/index-sections/Clients';
import BillboardSection from 'views/index-sections/BillboardSection';


// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import SectionDark from "views/index-sections/SectionDark";
import SectionDark2 from "views/index-sections/SectionDark2";


function LandingPage() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
      <IndexNavbar />
      <LandingPageHeader />
      <SectionDark />
      <SectionDark2 />
      <BillboardSection />
      <SectionNucleoIcons />

      <div className="main">
        <div id="services-section" style={{
          background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
          padding: '100px 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background decorative elements */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            background: 'rgba(102, 126, 234, 0.1)',
            borderRadius: '50%',
            zIndex: 1
          }}></div>
          
          <Container style={{ position: 'relative', zIndex: 2 }}>
            {/* Header Section */}
            <div className="text-center" style={{ marginBottom: '80px' }}>
              <h2 style={{
                color: 'white',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '20px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Our Premium Services
              </h2>
              <div style={{
                width: '100px',
                height: '4px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                margin: '0 auto 30px',
                borderRadius: '2px'
              }}></div>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.3rem',
                maxWidth: '800px',
                margin: '0 auto',
                lineHeight: '1.6',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                We provide comprehensive digital solutions to help your business thrive in the modern world. 
                From branding to web development, our expert team delivers exceptional results that drive growth and success.
              </p>
              <div style={{ marginTop: '40px' }}>
                <Button
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #667eea, #764ba2)',
                    border: 'none',
                    padding: '15px 40px',
                    borderRadius: '30px',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
                    transition: 'all 0.3s ease',
                    marginRight: '20px'
                  }}
                  href="https://chat.whatsapp.com/FYhyTQAInGk7ygMn2wiGTs"
                  target="_blank"
                >
                  <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} /> Join Our Group
                </Button>
                <Button
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    border: 'none',
                    padding: '15px 40px',
                    borderRadius: '30px',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                    boxShadow: '0 8px 25px rgba(255, 107, 107, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  href="#contact"
                >
                  Get Started Today
                </Button>
              </div>
            </div>

            {/* Services Grid */}
            <Row>
              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #667eea, #764ba2)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                  }}>
                    <i className="nc-icon nc-touch-id" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Branding
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(255, 107, 107, 0.3)'
                  }}>
                    <i className="nc-icon nc-mobile" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Advertising
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(79, 172, 254, 0.3)'
                  }}>
                    <i className="nc-icon nc-globe" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Digital Marketing
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #fa709a, #fee140)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(250, 112, 154, 0.3)'
                  }}>
                    <i className="nc-icon nc-laptop" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Web Development
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #a8edea, #fed6e3)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(168, 237, 234, 0.3)'
                  }}>
                    <i className="nc-icon nc-button-play" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Video Production
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #ff9a9e, #fad0c4)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(255, 154, 158, 0.3)'
                  }}>
                    <i className="nc-icon nc-camera-compact" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Photography
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #667eea, #764ba2)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                  }}>
                    <i className="nc-icon nc-single-02" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Social Media
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #f093fb, #f5576c)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(240, 147, 251, 0.3)'
                  }}>
                    <i className="nc-icon nc-palette" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Graphic Design
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(79, 172, 254, 0.3)'
                  }}>
                    <i className="nc-icon nc-zoom-split" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    SEO
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #fa709a, #fee140)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(250, 112, 154, 0.3)'
                  }}>
                    <i className="nc-icon nc-glasses-2" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Consultancy
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #a8edea, #fed6e3)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(168, 237, 234, 0.3)'
                  }}>
                    <i className="nc-icon nc-spaceship" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Business Development
                  </h4>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(45deg, #ff9a9e, #fad0c4)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 25px',
                    boxShadow: '0 8px 20px rgba(255, 154, 158, 0.3)'
                  }}>
                    <i className="nc-icon nc-send" style={{ fontSize: '30px', color: 'white' }} />
                  </div>
                  <h4 style={{ 
                    color: 'white', 
                    fontSize: '1.4rem', 
                    fontWeight: '600', 
                    marginBottom: '15px', 
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    SMS Marketing
                  </h4>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div id="team-section" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '100px 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background decorative elements */}
          <div style={{
            position: 'absolute',
            top: '-100px',
            left: '-100px',
            width: '300px',
            height: '300px',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '50%',
            zIndex: 1
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-150px',
            right: '-150px',
            width: '400px',
            height: '400px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '50%',
            zIndex: 1
          }}></div>
          
          <Container style={{ position: 'relative', zIndex: 2 }}>
            {/* Header Section */}
            <div className="text-center" style={{ marginBottom: '80px' }}>
              <h2 style={{
                color: 'white',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '20px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                Meet Our Amazing Team
              </h2>
              <div style={{
                width: '100px',
                height: '4px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                margin: '0 auto 30px',
                borderRadius: '2px'
              }}></div>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.3rem',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.6'
              }}>
                Meet the talented individuals behind Tri-Advise's success. Our diverse team of experts 
                brings creativity, innovation, and passion to every project we undertake.
              </p>
            </div>

            {/* Team Members */}
            <Row>
              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '25px',
                  padding: '40px 30px',
                  backdropFilter: 'blur(15px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s ease',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-15px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                }}>
                  {/* Profile Image */}
                  <div style={{
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    marginBottom: '30px',
                    border: '4px solid rgba(255,255,255,0.3)',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }}>
                    <img
                      alt="Nina Seifeddine"
                      src={require("assets/img/faces/ninaprofile.jpg").default}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  </div>
                  
                  {/* Name and Title */}
                  <h3 style={{
                    color: 'white',
                    fontSize: '1.8rem',
                    fontWeight: '600',
                    marginBottom: '10px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Nina Seifeddine
                  </h3>
                  <h4 style={{
                    color: '#feca57',
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    marginBottom: '25px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Head of Graphic Design Department
                  </h4>
                  
                  {/* Description */}
                  <p style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    marginBottom: '30px',
                    fontStyle: 'italic'
                  }}>
                    Creative visionary with a passion for transforming ideas into stunning visual experiences. 
                    Expert in brand identity and digital design.
                  </p>
                  
                  {/* Social Links */}
                  <div style={{ display: 'flex', gap: '15px', marginTop: 'auto' }}>
                  <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #0077B5, #005885)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(0, 119, 181, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="https://www.linkedin.com/in/nina-seif-eddine-612581216"
                    target="_blank"
                  >
                      <i className="fa fa-linkedin" style={{ marginRight: '8px' }} /> LinkedIn
                </Button>
                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="/team-nina"
                      target="_blank"
                    >
                      View Profile
                    </Button>
                  </div>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '25px',
                  padding: '40px 30px',
                  backdropFilter: 'blur(15px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s ease',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-15px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                }}>
                  {/* Profile Image */}
                  <div style={{
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    marginBottom: '30px',
                    border: '4px solid rgba(255,255,255,0.3)',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }}>
                    <img
                      alt="Hasan Awwad"
                      src={require("assets/img/faces/hasanprofile.jpg").default}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  </div>
                  
                  {/* Name and Title */}
                  <h3 style={{
                    color: 'white',
                    fontSize: '1.8rem',
                    fontWeight: '600',
                    marginBottom: '10px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Hasan Awwad
                  </h3>
                  <h4 style={{
                    color: '#feca57',
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    marginBottom: '25px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Application Development Team Lead
                  </h4>
                  
                  {/* Description */}
                  <p style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    marginBottom: '30px',
                    fontStyle: 'italic'
                  }}>
                    Technical leader passionate about creating elegant solutions and innovative applications. 
                    Expert in full-stack development and team management.
                  </p>
                  
                  {/* Social Links */}
                  <div style={{ display: 'flex', gap: '15px', marginTop: 'auto' }}>
                  <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #0077B5, #005885)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(0, 119, 181, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="https://www.linkedin.com/in/hasanawwad/"
                    target="_blank"
                  >
                      <i className="fa fa-linkedin" style={{ marginRight: '8px' }} /> LinkedIn
            </Button>
                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="/team-hasan"
                      target="_blank"
                    >
                      View Profile
                    </Button>
                  </div>
                </div>
              </Col>

              <Col md="4" style={{ marginBottom: '40px' }}>
                <div style={{
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '25px',
                  padding: '40px 30px',
                  backdropFilter: 'blur(15px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s ease',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-15px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                  e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                }}>
                  {/* Profile Image */}
                  <div style={{
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    marginBottom: '30px',
                    border: '4px solid rgba(255,255,255,0.3)',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }}>
                    <img
                      alt="Nour Shams"
                      src={require("assets/img/faces/nourprofile.jpg").default}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  </div>
                  
                  {/* Name and Title */}
                  <h3 style={{
                    color: 'white',
                    fontSize: '1.8rem',
                    fontWeight: '600',
                    marginBottom: '10px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Nour Shams
                  </h3>
                  <h4 style={{
                    color: '#feca57',
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    marginBottom: '25px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Head of Web Development Department
                  </h4>
                  
                  {/* Description */}
                  <p style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    marginBottom: '30px',
                    fontStyle: 'italic'
                  }}>
                    Web development expert with a passion for creating scalable and efficient solutions. 
                    Leading our development team with innovation and technical excellence.
                  </p>
                  
                  {/* Social Links */}
                  <div style={{ display: 'flex', gap: '15px', marginTop: 'auto' }}>
                  <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #0077B5, #005885)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(0, 119, 181, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="https://www.linkedin.com/in/nourshams/"
                    target="_blank"
                  >
                      <i className="fa fa-linkedin" style={{ marginRight: '8px' }} /> LinkedIn
          </Button>
                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                        border: 'none',
                        padding: '12px 20px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href="/team-nour"
                      target="_blank"
                    >
                      View Profile
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Call to Action */}
            <div className="text-center" style={{ marginTop: '60px' }}>
              <h3 style={{
                color: 'white',
                fontSize: '2rem',
                fontWeight: '600',
                marginBottom: '20px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Ready to Work With Us?
              </h3>
              <p style={{
                color: 'rgba(255,255,255,0.8)',
                fontSize: '1.2rem',
                marginBottom: '40px',
                maxWidth: '600px',
                margin: '0 auto 40px'
              }}>
                Join our team of passionate professionals and help us create amazing digital experiences.
              </p>
              <Button
                className="btn-round"
                style={{
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  border: 'none',
                  padding: '15px 40px',
                  borderRadius: '30px',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  boxShadow: '0 8px 25px rgba(255, 107, 107, 0.4)',
                  transition: 'all 0.3s ease'
                }}
                href="#contact"
              >
                Join Our Team
              </Button>
            </div>
          </Container>
        </div>

      </div>

      <Clients />

      <DemoFooter />
    </>
  );
}

export default LandingPage;
